import {postHtmlRequest} from "../utils/fetch";
import {IBaseStepContentRequest} from "./content-service";
const basePath = "/apicore/stepsapi/";
export function getStepContent(productCategory: string, selectedAttributeValueMa: string[], stepIndex: number, optionGroup?: string, targetDeliveryDate?: string, purpose?: string, occasion?: string, preselectedOccasion?:string, theme?: string) : Promise<string>{
	const body = {
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		productCategory: productCategory,
		selectedAttributeValueMa: selectedAttributeValueMa,
		stepIndex: stepIndex
	} as IBaseStepContentRequest;
	if (optionGroup && optionGroup !== 'undefined')
		body.optionGroup = optionGroup;
	if (targetDeliveryDate)
		body.targetDeliveryDate = targetDeliveryDate;
	if (purpose)
		body.purpose = purpose;
	if (occasion)
		body.occasion = occasion;
	if (preselectedOccasion)
		body.preselectedOccasion = preselectedOccasion;
	if (theme)
		body.theme = theme;

	return postHtmlRequest<IBaseStepContentRequest>(
		basePath + "getstepcontent",
		body,
		{ headers: new Headers({'Content-type': 'application/json; charset=utf-8'}) })
		.then() as Promise<string>;
}
